// Normalize
export const toMs = (v: unknown): number | null => {
  if (v == null) return null;

  if (typeof v === "string") {
    const s = v.trim();
    if (/^\d+$/.test(s)) {
      let n = Number(s);
      if (n >= 1e15) n = Math.round(n / 1000); // microseconds -> ms
      if (n < 1e12)  n = n * 1000;             // seconds -> ms
      return n;
    }
    const parsed = Date.parse(s);
    return Number.isNaN(parsed) ? null : parsed;
  }

  if (typeof v === "number") {
    if (v >= 1e15) return Math.round(v / 1000); 
    if (v < 1e12)  return v * 1000;             
    return v;                                    
  }

  return null;
};

// Format MM-DD-YYYY, TZ-aware (falls back to UTC)
export const formatDate = (ms: number, tz?: string): string => {
  const d = new Date(ms);
  if (isNaN(d.getTime())) return "N/A";
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: tz || "UTC",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(d);
  const mm = parts.find(p => p.type === "month")?.value ?? "";
  const dd = parts.find(p => p.type === "day")?.value ?? "";
  const yyyy = parts.find(p => p.type === "year")?.value ?? "";
  return `${mm}-${dd}-${yyyy}`;
};

export const epochComparator = (a: unknown, b: unknown) =>
  (toMs(a) ?? -Infinity) - (toMs(b) ?? -Infinity);
